import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo.webp'
import './style.css'

const Footer = (props) => {
    return (
        <div className="tp-site-footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="footer-image">
                            <Link className="logo" to="/"><img src={Logo} alt="" /></Link>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="link-widget">
                            <ul>
                                <li><a href="https://www.instagram.com/studyabroad_with_asslam" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a></li>
                                <li><a href="https://www.facebook.com/AsslamIShaikh" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                <li><a href="https://www.linkedin.com/in/asslamishaikh/" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                <li><a href="https://x.com/AsslamIShaikh" target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" style={{verticalAlign:'middle'}}><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="copyright">
                            <p>© {new Date().getFullYear()}. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;